// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2879":"17a2a0f6","3591":"17a2a0f6","4387":"17a2a0f6","5151":"17a2a0f6","7748":"17a2a0f6","8034":"17a2a0f6"}[chunkId] + ".chunk.css";
};